// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7be65952","337":"16ba2914","667":"9e03e451"}[chunkId] + ".chunk.js";
};